module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_0.3a74b549.png";